<template>
  <div class="footer">
    <p>
      <a href="http://fanyi.youdao.com" target="_blank" rel="nofollow">有道翻译</a>-
      <a href="http://www.youdao.com" target="_blank" rel="nofollow">有道首页</a>-
      <a href="https://ke.youdao.com/?keyfrom=f.youdao" target="_blank" rel="nofollow">有道精品课</a>-
      <a href="http://www.youdao.com/about/index.html" target="_blank" rel="nofollow">关于有道</a>-
      <a href="http://i.youdao.com" target="_blank" rel="nofollow">官方博客</a>-
      <a href="http://dsp.youdao.com" target="_blank" rel="nofollow">有道智选</a>-
      <a href="/?path=terms-of-service" target="_blank" rel="nofollow">有道人工翻译服务条款</a>-
      <a href="/?path=privacy" target="_blank" rel="nofollow">隐私条例</a>-
      <a
        href="http://survey2.163.com/html/zyfy_satisfiction/paper.html?site=fankui"
        class="clog-js"
        data-act="feedback"
        target="_blank"
        rel="nofollow"
      >意见反馈</a>
    </p>
    <p>
      <span>©2019</span>
      <span>网易公司</span>
      <span>京ICP证080268号</span>
    </p>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>
a{
    line-height: 1.5em;
    margin: 0 8px;
    color: #666;
}
a:hover{
    background-color: transparent;
    text-decoration: underline;
    color: #929292;
}
span{
    margin: 0 5px;
    color: #666;
}
.footer{
    background-color: #F7F9FA;
    line-height: 24px;
    padding: 29px 0;
    text-align: center;
    color: #bcbcbc;
    font-size: 12px;
}
</style>
